import popMgr from '@/components/global/popMgr';
import util from '@/common/util';
import { isSSRServer } from '@/config';
import { getStore } from '@/store';
import registerPhoneValidPop from './index.vue';
import { adNewQuestions } from '@/components/adQuestionsPop/index.js';

export const adNewPhoneValid = {
    hasPhoneAddOn: false,
    hasValidPhone: false,
    showNewRegister() {
        if (isSSRServer) {
            return false;
        }
        return !!(
            (util.getCookie('old_reg_modal') == 'false' || util.getQueryField('old_reg_modal') == 'false') // && util.getCookie('_ads_source')
        );
    },
    // todo 20241015
    // Currently, it is written in several registration entrances. 
    // When all registration entrances can go through the new advertising process, this method will be called in the public registration method.
    addAdNewRegisterParams() {
        let obj = {};
        if (this.showPhoneValidPop()) {
            obj.usePhoneValid = true;
        }
        if (this.showNewRegister()) {
            obj.registerNewPopupBehavior = true;
        }
        return obj;
    },
    // Display the phone number verification page, otherwise display the completion page
    showPhoneValidPage() {
        return !!(this.showPhoneValidPop() && this.hasRegisterphoneNumber());
    },
    showPhoneValidPop() {
        return this.hasPhoneAddOn && !this.hasValidPhone;
    },
    hasRegisterphoneNumber() {
        return !!getStore('user')?.user?.phoneNumber;
    },
    async init() {
        if (!this.showNewRegister()) {
            return;
        }
        await this.getHasPhoneAddOn();
        if (!!getStore('user')?.user) {
            await this.getValidPhone();
        }
    },
    getHasPhoneAddOn() {
        window.siteAxios
            .get('/api-site/register/phone-addon?_t=' + Date.now())
            .then(res => {
                this.hasPhoneAddOn = !!res?.data;
            });
    },
    getValidPhone() {
        return window.siteAxios
            .get('/api-site/questionnaire/leadBehaviorAction?_t=' + Date.now())
            .then(res => {
                const list = res?.data || [];
                const index = list.findIndex(
                    item => item.behavior == 'alreadyValidPhone'
                );
                this.hasValidPhone = index >= 0;
            });
    },
    // Display the phone number page or completion page
    async openRegisterPhoneValidPop(options = {}) {
        if (!this.showNewRegister()) {
            return;
        }
        if (!getStore('user')?.user) {
            return;
        }
        const showPhonePop = this.showPhoneValidPage();
        console.log('openRegisterPhoneValidPop ===>>>>', showPhonePop);
        if (showPhonePop) {
            popMgr.create(registerPhoneValidPop, {
                currentStep: 1,
                ...options
            });
        } else {
            await adNewQuestions.init();
            adNewQuestions.openAdQuestionPop();
        }
    },

    // Display the phone number page and completion page
    async showRegisterPhoneAndCompletionPage() {
        if (!this.showNewRegister()) {
            return false;
        }
        if (!getStore('user')?.user) {
            return false;
        }
        try {
            await this.getValidPhone();
        } catch (e) {
            console.log(e);
        }
        if (!this.showPhoneValidPage()) {
            return false;
        }
        return true;
    }
};
